<template>
  <div class="card-content">
    <md-field
      class="card-text-area"
      :class="[{ 'card-text-area-item-details': isItemDetailContent }]"
    >
      <md-textarea
        v-model="message"
        placeholder="Type here..."
        @keyup.enter.exact="send"
        @keydown.enter.exact.prevent
        :data-cy="`text-area-input-${itemName}`"
        class="type-box-size"
      >
      </md-textarea>
    </md-field>
    <md-button
      class="md-icon-button md-raised md-primary send-message-button"
      @click.prevent="send"
      :data-cy="`sendMessage-${itemName}`"
    >
      <md-icon>send</md-icon>
    </md-button>
  </div>
</template>

<script>
import ChatHelperVue from "@/mixins/ChatHelper.vue";

export default {
  name: "CardChatResponse",
  mixins: [ChatHelperVue],
  props: ["itemName", "isItemDetailContent"],
  data() {
    return {
      message: "",
      labelText: "Reply",
    };
  },
  methods: {
    send() {
      this.$emit("send", this.message);
      this.message = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.card-text-area {
  height: 40px !important;
  width: 77% !important;
  padding-top: 0px !important;
  margin-left: 0.3rem;
  textarea {
    min-height: 38px !important;
    overflow: scroll;
    resize: none !important;
    padding: 7px 16px !important;
  }
  textarea:focus {
    padding-top: 7px !important;
  }
}
.card-content {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
}
.send-message-button {
  margin-top: -1.5rem;
  margin-left: 1rem;
  background-color: $tertiary !important;
}
.type-box-size {
  width: 99%;
}
.card-text-area-item-details {
  width: 100% !important;
  margin-top: 0.5rem;
}
@media screen and (max-width: 360px) {
  .card-text-area {
    width: 80% !important;
  }
}
</style>

<style lang="scss">
.card-content .md-field:after,
.card-content .md-field:before {
  border: 1px solid $dark !important;
  border-radius: 30px !important;
}
::-webkit-scrollbar-thumb {
  background: #757575;
  border-radius: 6px;
}
::-webkit-scrollbar-track {
  display: none;
}
::-webkit-scrollbar-button {
  display: none;
}
::-webkit-scrollbar:horizontal{
  display: none;
}
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track-piece {
  width: 8px;
}
</style>
